export class M3PerXProceso{
    public TipoPersona:string;
    public Tdoc:string;
    public Ndoc:string;    
    public Nombre:string;
    public DescTipoP:string;
}
